import {
  GET_LABREQUESTSURVEY_FAIL,
  GET_LABREQUESTSURVEY_SUCCESS,
  GET_LABREQUESTSURVEYS_FAIL,
  GET_LABREQUESTSURVEYS_SUCCESS,
  ADD_LABREQUESTSURVEY_SUCCESS,
  ADD_LABREQUESTSURVEY_FAIL,
  UPDATE_LABREQUESTSURVEY_SUCCESS,
  UPDATE_LABREQUESTSURVEY_FAIL,
  DELETE_LABREQUESTSURVEY_SUCCESS,
  DELETE_LABREQUESTSURVEY_FAIL,  
  SET_STATE_LABREQUESTSURVEY,
  GET_LABREQUESTSURVEYSCALCULATE_SUCCESS,
  GET_LABREQUESTSURVEYSCALCULATE_FAIL
} from "./actionTypes";

const INIT_STATE = {
  labRequestSurveys: [],
  labRequestSurvey: {},
  calculate: [],
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestSurveys = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTSURVEYS_SUCCESS:
      return {
        ...state,
        labRequestSurveys: action.payload.labRequestSurveys,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };
    
    case GET_LABREQUESTSURVEYSCALCULATE_SUCCESS:
      return {
        ...state,
        calculate: action.payload.labRequestSurveysCalculate,
      };

    case SET_STATE_LABREQUESTSURVEY:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTSURVEYS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTSURVEYSCALCULATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTSURVEY_SUCCESS:
      return {
        ...state,
        labRequestSurveys: [...state.labRequestSurveys, action.payload],
      };
    
    case GET_LABREQUESTSURVEYS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTSURVEY_SUCCESS:
      return {
        ...state,
        labRequestSurveys: [...state.labRequestSurveys, action.payload],
      };

    case ADD_LABREQUESTSURVEY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTSURVEY_SUCCESS:
      return {
        ...state,
        labRequestSurveys: state.labRequestSurveys.map(labRequestSurvey =>
          labRequestSurvey.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestSurvey }
            : labRequestSurvey
        ),
      };

    case UPDATE_LABREQUESTSURVEY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTSURVEY_SUCCESS:
      return {
        ...state,
        labRequestSurveys: state.labRequestSurveys.filter(
          labRequestSurvey => labRequestSurvey.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTSURVEY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTSURVEY_SUCCESS:
      return {
        ...state,
        labRequestSurvey: action.payload,
      };

    case GET_LABREQUESTSURVEY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestSurveys;
